module.exports = __webpack_public_path__ + "assets/img/tedian3.5ecbfe90.png";